import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"

const IndexPage = ({ data }) => {
  
  const accounts = data?.allAccount?.nodes || []

  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '30px' }}>
          Client Websites ({accounts.length})
        </h1>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
          gap: '20px' 
        }}>
          {accounts.map((account) => (
            <div
              key={account.id}
              style={{
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '20px',
                backgroundColor: 'white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              <h3 style={{ margin: '0 0 10px 0' }}>{account.name}</h3>
              <p style={{ 
                margin: '0 0 15px 0', 
                color: account.status === 'active' ? 'green' : 
                       account.status === 'pending' ? 'orange' : 'red',
                textTransform: 'capitalize'
              }}>
                Status: {account.status}
              </p>
              { JSON.stringify(account)}
              <Link
                to={`/family/${account.mongoId}`}
                style={{
                  display: 'inline-block',
                  padding: '10px 20px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              >
                View Website
              </Link>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export const Head = () => <Seo title="Client Websites Dashboard" />

export const query = graphql`
  query {
    allAccount {
      nodes {
        id
        mongoId
        name
        status
      }
    }
  }
`

export default IndexPage